import classnames from 'clsx';

import { FlexColumn } from 'ui-components/components/flex';

import style from './card.module.css';

import type { CardComponent } from './card-types';

/**
 * @deprecated Use `Card` from `@mantine/core` instead. For interactive cards, use `ClickableCard` from `@shipstation/client-common/components/clickable-card`.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const Card: CardComponent = ({ className, children }) => {
  return <FlexColumn className={classnames(style['card-wrapper'], className)}>{children}</FlexColumn>;
};
